import {useIntl} from 'react-intl';
import React , { useState, useEffect } from "react";
import { Label, Icon } from "semantic-ui-react";
import {getAbbrSurface} from "react-lib/apps/common/CUDENT/DentalRecordUtil";
import toothDetails from "react-lib/apps/common/CUDENT/ToothDetails";

const GuideLine = (props) => {
  const intl = useIntl();
  const [nameTooth, setNameTooth] = useState("")

  // console.log("props.selectorMode", props.selectorMode);
  // console.log("GuideLine ~   props.filterItem",   props.filterItem)
  // console.log("GuideLine ~ props.openClinicalFindingsMenu", props.openClinicalFindingsMenu)
  // console.log("GuideLine ~ props.controller", props.controller)


  useEffect(() => {
    

    // console.log( "props.filterItem." ,props.filterItem)
    if (props.filterItem) { 
      console.log('props.filterItem: ', props.filterItem); // T41-5, T41-3 , T31-cs
      const organItems = props.controller.data.organ.items
      
      let q = props.filterItem.substring(1,2)
      let i = props.filterItem.substring(2,3)
      let section = props.filterItem.substring(4,5) 
  
      let surfaceName = toothDetails.find( item => item.q === Number(q) && item.i === Number(i) )?.surfaceName[Number(section)]
      if ( surfaceName && surfaceName !== "Whole") {
        console.log('surfaceName: ', surfaceName);
  
        let nickName = q + i + getAbbrSurface(surfaceName)  
        // console.log(" nickName", nickName)
        
        let list = organItems.filter(item => item.secondary?.length === 1 && item.i === Number(i) && item.q === Number(q))
        // console.log("list", list)
        let foundTooth = list.filter(item => item.nickName ===  nickName)
        // console.log("foundTooth", foundTooth)
        if (foundTooth.length === 1) {
          setNameTooth(foundTooth[0].fullName)
        }

      } else if (surfaceName === "Whole" )  { 
        setNameTooth("" + q + i)
      } else if (section === "c") {
        setNameTooth(q + i + " (Superteeth)")
      }
    }
  }, [props.filterItem,  props.controller.data.organ?.items])



  return (
    <>
      {props.selectorMode ? (
        <div style={{ display: "flex", alignItems: "center", marginLeft: "10px" }}>
          <Label style={{ display: "flex", alignItems: "center" }}>
            <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: "cukey229" }) }} />
            <Icon name="plus" />
            {intl.formatMessage({ id: "cukey252" })}
          </Label>
        </div>
      ) : null}

      {props.filterItem ? (
        <div style={{ display: "flex", alignItems: "center", marginLeft: "10px" }}>
          <Label>
            {intl.formatMessage({ id: "cukey230" })}
            <Icon name="filter" />
            {intl.formatMessage({ id: "cukey305" })} {nameTooth} {intl.formatMessage({ id: "cukey439" })}
          </Label>
        </div>
      ) : null}

      {props.openClinicalFindingsMenu ? (
        <div style={{ display: "flex", alignItems: "center", marginLeft: "10px" }}>
          <Label style={{ display: "flex", alignItems: "center" }}>
            <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: "cukey229" }) }} />
            <Icon name="hand pointer" />
          </Label>
        </div>
      ) : null}
    </>
  );
};




export default GuideLine;
